<template>
  <div class="funder-documents">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1>{{ furtherDocumentsPageHeading }}</h1>
        </div>
      </div>
      <template v-if="isSalSacOrder">
        <div class="row sal-sac-agreement">
          <div class="col-12" style="max-width: 900px">
            <form method="POST" @submit.prevent="signSalarySacrificeAgreement">
              <h2 class="sal-sac-agreement-title">{{ agreementHeading }}</h2>
              <h3 class="sal-sac-agreement-subtitle">{{ agreementSubTitle }}</h3>
              <p>Employee Name: <strong>{{ driverName }}</strong></p>
              <div class="agreement-intro" v-html="agreementIntroFixed"></div>
              <p>By agreeing to these terms & conditions, you understand and agree to the following:</p>
              <div class="agreement-body" v-html="agreementBodyFixed"></div>

              <p class="mb-4">Insurance declaration: You can confirm that you have read and understood the Policy Summary and the Eligibility Criteria, and you can confirm that at point of order you and all drivers whom
                you wish to drive the car meet the eligibility criteria.</p>
              <hr>
              <p class="signed">Signed</p>
              <template v-if="!fetchingAgreement">
                <input type="text" name="full_name" v-model="payload.fullName" placeholder="Please enter your full name" required :disabled="signedAt">

                <template v-if="!signedAt">
                  <div class="agree mb-0">
                    <input type="checkbox" name="confirm_1" id="confirm_1" v-model="payload.acceptedAgreement" class="confirm" required>
                    <label for="confirm_1">
                      I confirm that I have read and accept the Salary Sacrifice Agreement
                    </label>
                  </div>

                  <button type="submit" class="button button--steelBlue mt-5 float-end">SUBMIT CONFIRMATION <i class="icon-arrow-right"></i></button>
                </template>
                <template v-else>
                  <div class="signed-at mt-2">Signed at {{ signedAt }}</div>
                </template>
              </template>
            </form>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="row">
          <div class="col-12">
            <iframe :src="iframeURL" width="100%" class="funder-docs-iframe"/>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {EventBus} from '@/event-bus.js';

export default {
  name: "funder-documents",
  data() {
    return {
      fetchingAgreement: true,
      signedAt: null,
      payload: {
        fullName: '',
        acceptedAgreement: false
      },
      agreementBody: this.adminPortalData?.content?.products?.salsac?.[0]?.salary_sacrifice_agreement_body,
      agreementIntro: this.adminPortalData?.content?.products?.salsac?.[0]?.salary_sacrifice_intro,
    };
  },
  props: ['order', 'driverProfile', 'product', 'isSalSacOrder', 'quoteCosts', 'adminPortalData'],
  mounted() {
    if (this.isSalSacOrder) {
      this.loadingText = 'Checking Order';
      this.loading = true;

      try {
        this.$http.post('/api/get-salary-sacrifice-order', {
          orderNumber: this.order.orderID
        })
          .then(response => {

            this.loading = false;
            this.loadingText = null;
            this.fetchingAgreement = false;

            if (response.data.data) {
              if (response.data.data.signed_at) {
                this.payload.fullName = response.data.data.signature;
                this.signedAt = (new Date(response.data.data.signed_at)).toLocaleDateString('en-GB', {hour: '2-digit', minute: '2-digit'});
              }
            }

          })
          .catch(err => {
            EventBus.$emit('loading', false);
            let response = err.response.data;

            this.$notify({
              group: 'notify',
              type: 'error',
              title: 'Error',
              text: response.error.message
            });
            this.error = err.message.toString();
            this.$router.push({name: response.redirect, params: {...this.$route.params}});
          });
      } catch (err) {
        EventBus.$emit('loading', false);

        this.$notify({
          group: 'notify',
          type: 'error',
          title: 'Error',
          text: err
        });
      }
    }
  },
  computed: {
    iframeURL() {
      const uri = process.env.MIX_CAR_BENEFIT_URL;
      const apikey = process.env.MIX_CAR_BENEFIT_APIKEY
      const orderNumber = this.order.orderID;
      const emailAddress = this.driverProfile.contacts[0].emailAddress;

      return "https://" + uri + "/CBS/ExternalSupport/GetAgreementDocumentForSigning?orderno=" + orderNumber + "&driveremail=" + emailAddress + "&apikey=" + apikey
    },
    furtherDocumentsPageHeading() {
      return this.product?.further_documents_page_heading ? this.product.further_documents_page_heading : '';
    },
    driverName() {
      return this.driverProfile?.firstName + ' ' + this.driverProfile?.surname;
    },
    driverEmailAddress() {
      return this.driverProfile?.contacts ? this.driverProfile.contacts[0].emailAddress : null;
    },
    companyName() {
      return this.driverProfile?.customerName;
    },
    grossAnnualSacrifice() {
      return Number(this.quoteCosts.gross_monthly_sacrifice * 12).toFixed(2);
    },
    grossMonthlySacrifice() {
      return Number(this.quoteCosts.gross_monthly_sacrifice).toFixed(2);
    },
    agreementHeading() {
      console.log(this.adminPortalData.content.products);
      return this.adminPortalData.content.products.salsac[0].salary_sacrifice_agreement_page_heading
        .replace(/{COMPANY_NAME}/g, this.companyName);
      ;
    },
    agreementSubTitle() {
      return this.adminPortalData.content.products.salsac[0].salary_sacrifice_agreement_page_sub_title
        .replace(/{COMPANY_NAME}/g, this.companyName);
    },
    agreementIntroFixed() {
      return this.agreementIntro.replace(/{COMPANY_NAME}/g, this.companyName);
    },
    agreementBodyFixed() {
      return this.agreementBody.replace(/{COMPANY_NAME}/g, this.companyName)
        .replace(/{GROSS_ANNUAL_SACRIFICE}/g, this.grossAnnualSacrifice)
        .replace(/{GROSS_MONTHLY_SACRIFICE}/g, this.grossMonthlySacrifice)
        .replace(/{VEHICLE_MAKE}/g, this.order.vehicle.manufacturerName)
        .replace(/{VEHICLE_MODEL}/g, this.order.vehicle.modelName)
        .replace(/{VEHICLE_DERIVATIVE}/g, this.order.vehicle.derivativeName);
    }

  },
  methods: {
    signSalarySacrificeAgreement() {

      this.loadingText = 'Submitting Confirmation';
      this.loading = true;

      try {
        this.$http.post('/api/submit-salary-sacrifice-funding-agreement', {
          fullName: this.payload.fullName,
          acceptedAgreement: this.payload.acceptedAgreement,
          orderNumber: this.order.orderID,
          driverName: this.driverName,
          driverEmailAddress: this.driverEmailAddress,
          companyName: this.companyName,
          grossAnnualSacrifice: this.grossAnnualSacrifice,
          grossMonthlySacrifice: this.grossMonthlySacrifice,
          productType: this.product?.type,
          vehicleMake: this.order.vehicle.manufacturerName,
          vehicleModel: this.order.vehicle.modelName,
          vehicleDerivative: this.order.vehicle.derivativeName
        })
          .then(response => {

            this.loading = false;
            this.loadingText = null;

            if (response.data.status == 200) {

              this.$notify({
                group: 'notify',
                type: 'success',
                title: 'Success',
                text: 'Agreement submitted successfully'
              });

              if (response.data.data) {
                this.payload.fullName = response.data.data.signature;
                this.signedAt = (new Date(response.data.data.signed_at)).toLocaleDateString('en-GB', {hour: '2-digit', minute: '2-digit'})
              }
            }

            if (response.data.error) {
              throw response.data.error;
            }

          })
          .catch(err => {
            EventBus.$emit('loading', false);
            let response = err.response.data;

            this.$notify({
              group: 'notify',
              type: 'error',
              title: 'Error',
              text: response.error.message
            });
            this.error = err.message.toString();
            this.$router.push({name: response.redirect, params: {...this.$route.params}});
          });
      } catch (err) {
        EventBus.$emit('loading', false);

        this.$notify({
          group: 'notify',
          type: 'error',
          title: 'Error',
          text: err
        });
      }
    },
  }
}
</script>

<style scoped lang="scss">

.funder-documents {
  padding: 4rem 0;
}

.funder-docs-iframe {
  min-height: 200vh;
  border: 0;
}

</style>
